import React, { createContext, useEffect, useState } from 'react';
import { EnrichedFieldUsage } from './types';
import useGetFieldUsage from './getFieldUsage/useGetFieldUsage';
import isDefined from '../../../../../isDefined';
import _ from 'lodash';

type FieldUsageMap = Record<string, EnrichedFieldUsage>;

const FieldUsageContext = createContext<{ usages: FieldUsageMap }>({
  usages: {},
});

const FieldUsageProvider = ({
  children,
  baseView,
}: {
  children: React.ReactNode;
  baseView: FleetOps.BaseView;
}) => {
  const [fields, setFields] = useState<string[]>([]);
  const [usages, setUsages] = useState<FieldUsageMap>({});
  const getFieldUsage = useGetFieldUsage();

  useEffect(() => {
    const newFields = Object.values(baseView.fields)
      .filter(isDefined)
      .map((f) => f.field);

    setFields((current) => {
      if (_.isEqual(current, newFields)) {
        return current;
      }

      return newFields;
    });
  }, [baseView.fields]);

  useEffect(() => {
    const newUsages: FieldUsageMap = {};
    fields.forEach((field) => {
      newUsages[field] = getFieldUsage(field);
    });
    setUsages(newUsages);
  }, [fields, getFieldUsage]);

  return (
    <FieldUsageContext.Provider
      value={{
        usages,
      }}
    >
      {children}
    </FieldUsageContext.Provider>
  );
};

export { FieldUsageContext, FieldUsageProvider };
